import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const SurveyCode = ({
  surveyCode,
}) => {
  const {
    EnterCode,
  } = useSelector((state) => state);

  return (
    <>
      <p>{EnterCode}: {surveyCode.match(/.{1,4}/g).join(' ')}</p>
    </>
  );
};

SurveyCode.defaultProps = {
  surveyCode: '',
};

SurveyCode.propTypes = {
  surveyCode: PropTypes.string,
};

export default SurveyCode;
